import axios from "axios";
import { baseUrl } from "../config/app.config";
import firestore from "../config/firebase";

export const GetAllWebinars = async () => {
  let result = { error: false, data: "" };

  try {
    var response = await axios.get(baseUrl + "/api/Webinar/GetWebinars");
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetActiveWebinars = async () => {
  let result = { error: false, data: "" };

  try {
    var response = await axios.get(baseUrl + "/api/Webinar/GetActiveWebinars");
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetRatingQuestionnaire = async () => {
  let result = { error: false, data: "" };

  try {
    var response = await axios.get(
      baseUrl + "/api/Webinar/GetRatingsQuestionnaire"
    );
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const getWebinarContents = async (docId, collectionName) => {
  return await firestore
    .collection(collectionName)
    .doc(docId)
    .get();
};

export const UpdateWebinarStatus = async webinar => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Webinar/UpdateWebinar",
      data: webinar
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const GetPresentations = async accessToken => {
  let result = { error: false, data: "" };

  try {
    var response = await axios({
      method: "get",
      headers: {
        Authorization: "Bearer " + accessToken
      },
      url: "https://www.googleapis.com/drive/v3/files"
    });
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetSlides = async (accessToken, presentationId) => {
  let result = { error: false, data: "" };

  try {
    var response = await axios({
      method: "get",
      headers: {
        Authorization: "Bearer " + accessToken
      },
      url:
        "https://slides.googleapis.com/v1/presentations/" +
        presentationId +
        "?fields=slides.objectId"
    });
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};

export const GetThumbnail = async (accessToken, presentationId, objectId) => {
  let result = { error: false, data: "" };

  try {
    var response = await axios({
      method: "get",
      headers: {
        Authorization: "Bearer " + accessToken
      },
      url:
        "https://slides.googleapis.com/v1/presentations/" +
        presentationId +
        "/pages/" +
        objectId +
        "/thumbnail"
    });
    result.data = response.data;
  } catch (error) {
    console.log(error);
    result.error = true;
    result.data = error.response;
  }
  return result;
};
